import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from 'components/user/AuthContext';
import Avatar from 'components/user/Avatar';
import TwutForm from './TwutForm';

const CreateTwut = ({ onSubmit, isPosting }) => {
  const { user } = useContext(AuthContext);

  return (
    <div className="twut bg-gray-weakest border border-gray-less p-4 mb-4 rounded-lg flex items-start space-x-4">
      <Link to={`/${user.username}`}>
        <Avatar src={user.avatar} alt={user.name} />
      </Link>
      <div className="content flex-1">
        <TwutForm onSubmit={onSubmit} isProcessing={isPosting} />
      </div>
    </div>
  );
}

export default CreateTwut;
